'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'backward';
var width = 512;
var height = 512;
var aliases = [9194];
var unicode = 'f04a';
var svgPathData = 'M481.4 64c-6.75 0-13.41 2.344-18.91 6.875l-152.6 125.3c-6.812 5.609-7.812 15.69-2.219 22.52c5.656 6.828 15.75 7.797 22.53 2.203L480 95.59v320.8l-149.8-125.3c-6.781-5.594-16.88-4.625-22.53 2.203c-5.594 6.828-4.594 16.91 2.219 22.52l152.6 125.3C467.1 445.7 474.6 448 481.4 448C497.5 448 512 434.6 512 415.1V96.03C512 77.44 497.5 64 481.4 64zM225.4 64C218.6 64 211.1 66.34 206.5 70.88L11.69 230.8C4.25 236.9 0 246.1 0 256s4.25 19.06 11.69 25.16l194.8 159.1C211.1 445.7 218.6 448 225.4 448c10.35 0 30.6-8.122 30.6-32.03v-319.9C255.1 72.12 235.7 64 225.4 64zM224 416.4L32.52 256L224 95.59V416.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBackward = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;